import { useQuery } from '@apollo/react-hooks';
import { kmsClient } from 'api';
import { CAMPAIGNS_QUERY } from './articleGroupCampaigns.query';
import {
  ArticleGroupCampaignQuery,
  ArticleGroupCampaignQuery_articleGroup_articles,
  ArticleGroupCampaignQuery_articleGroup_articles_campaign,
  ArticleGroupCampaignQueryVariables
} from './__generated__/ArticleGroupCampaignQuery';

export const useArticleGroupCampaignQuery = (variables: ArticleGroupCampaignQueryVariables) => {
  return useQuery<ArticleGroupCampaignQuery>(CAMPAIGNS_QUERY, {
    client: kmsClient,
    variables,
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true
  });
};

export const getCampaignsFromQuery = (
  qeuery: ArticleGroupCampaignQuery
): ArticleGroupCampaignQuery_articleGroup_articles_campaign[] => {
  const campaigns: { [key: number]: string } = {};

  qeuery.articleGroup.articles.forEach((article: ArticleGroupCampaignQuery_articleGroup_articles) => {
    campaigns[article.campaign.id] = article.campaign.name;
  });

  return Object.keys(campaigns).map((key) => ({
    id: +key,
    name: campaigns[+key]
  }));
};
